webpackJsonp([113068314854862],{

/***/ 199:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ConferenceAgenda = function ConferenceAgenda() {
		return _react2.default.createElement(
			"section",
			{ id: "agenda", className: "parallax-section" },
			_react2.default.createElement(
				"div",
				{ className: "container" },
				_react2.default.createElement("br", null),
				_react2.default.createElement("br", null),
				_react2.default.createElement("br", null),
				_react2.default.createElement("br", null),
				_react2.default.createElement("br", null),
				_react2.default.createElement(
					"div",
					{ className: "row" },
					_react2.default.createElement(
						"div",
						{ className: "col-md-offset-2 col-md-8 col-sm-offset-2 col-sm-8" },
						_react2.default.createElement(
							"div",
							{ className: "header-title" },
							_react2.default.createElement(
								"h3",
								{ className: "heading" },
								"Agenda"
							),
							_react2.default.createElement("hr", null),
							_react2.default.createElement(
								"p",
								null,
								"2020 Edition schedule - this is a draft and it can change without notice.",
								_react2.default.createElement("br", null),
								"* Please note lunch is not provided."
							)
						)
					),
					_react2.default.createElement(
						"div",
						{ className: "col-md-12 col-sm-6 wow fadeInUp" },
						_react2.default.createElement(
							"div",
							{ className: "team-wrapper" },
							_react2.default.createElement(
								"div",
								{ className: "team-des agenda-center" },
								_react2.default.createElement(
									"h4",
									null,
									"8:00 - 9:00"
								),
								_react2.default.createElement(
									"h5",
									null,
									"REGISTRATION"
								)
							)
						)
					),
					_react2.default.createElement(
						"div",
						{ className: "col-md-12 col-sm-6 wow fadeInUp animated" },
						_react2.default.createElement(
							"div",
							{ className: "team-wrapper" },
							_react2.default.createElement(
								"div",
								{ className: "team-des agenda-center" },
								_react2.default.createElement(
									"h4",
									null,
									"9:00 - 9:10"
								),
								_react2.default.createElement(
									"h5",
									null,
									"CONFERENCE OPENING"
								),
								_react2.default.createElement(
									"p",
									null,
									_react2.default.createElement(
										"b",
										null,
										"\xA0"
									)
								)
							)
						)
					),
					_react2.default.createElement(
						"div",
						{ className: "col-md-12 col-sm-6 wow fadeInUp animated" },
						_react2.default.createElement(
							"div",
							{ className: "team-wrapper" },
							_react2.default.createElement(
								"div",
								{ className: "team-des agenda-center" },
								_react2.default.createElement(
									"h4",
									null,
									"9:10 - 9:55"
								),
								_react2.default.createElement(
									"h5",
									null,
									_react2.default.createElement(
										"a",
										{ href: "/speakers/mathias-verraes" },
										"Opening keynote"
									)
								),
								_react2.default.createElement(
									"b",
									null,
									_react2.default.createElement(
										"a",
										{ href: "/speakers/mathias-verraes" },
										"Mathias Verraes"
									)
								),
								_react2.default.createElement(
									"p",
									null,
									_react2.default.createElement(
										"a",
										{ href: "/speakers/mathias-verraes" },
										"Temporal Coupling"
									)
								)
							)
						)
					),
					_react2.default.createElement(
						"div",
						{ className: "col-md-12 col-sm-6 wow fadeInUp animated" },
						_react2.default.createElement(
							"div",
							{ className: "team-wrapper" },
							_react2.default.createElement(
								"div",
								{ className: "team-des agenda-center" },
								_react2.default.createElement(
									"h4",
									null,
									"9:55 - 10:25"
								),
								_react2.default.createElement(
									"h5",
									null,
									"COFFEE BREAK & TRACKS SEPARATION"
								)
							)
						)
					),
					_react2.default.createElement(
						"div",
						{ className: "col-md-4 col-sm-6 wow fadeInUp" },
						_react2.default.createElement(
							"div",
							{ className: "team-wrapper" },
							_react2.default.createElement(
								"div",
								{ className: "team-des agenda-center" },
								_react2.default.createElement(
									"h4",
									null,
									"CLOUD NATIVE"
								)
							)
						),
						_react2.default.createElement(
							"div",
							{ className: "team-wrapper" },
							_react2.default.createElement(
								"div",
								{ className: "team-des agenda-center-track" },
								_react2.default.createElement(
									"h4",
									null,
									"10:25 - 10:30"
								),
								_react2.default.createElement(
									"b",
									null,
									_react2.default.createElement(
										"a",
										{ href: "/tracks/cloudnative" },
										"Track Powered By Mambu"
									)
								),
								_react2.default.createElement("br", null),
								_react2.default.createElement(
									"a",
									{ href: "/tracks/cloudnative" },
									"opening by host"
								),
								_react2.default.createElement("br", null),
								_react2.default.createElement(
									"b",
									null,
									_react2.default.createElement(
										"a",
										{ href: "https://www.linkedin.com/in/pavelchunyayev/", target: "_blank" },
										"Pavel Chunyayev"
									)
								)
							)
						)
					),
					_react2.default.createElement(
						"div",
						{ className: "col-md-4 col-sm-6 wow fadeInUp" },
						_react2.default.createElement(
							"div",
							{ className: "team-wrapper" },
							_react2.default.createElement(
								"div",
								{ className: "team-des agenda-center" },
								_react2.default.createElement(
									"h4",
									null,
									"ARCHITECTURE"
								)
							)
						),
						_react2.default.createElement(
							"div",
							{ className: "team-wrapper" },
							_react2.default.createElement(
								"div",
								{ className: "team-des agenda-center-track" },
								_react2.default.createElement(
									"h4",
									null,
									"10:25 - 10:30"
								),
								_react2.default.createElement(
									"b",
									null,
									_react2.default.createElement(
										"a",
										{ href: "/tracks/architecture" },
										"Track Powered By Centric"
									)
								),
								_react2.default.createElement("br", null),
								_react2.default.createElement(
									"a",
									{ href: "/tracks/architecture" },
									"opening by host"
								),
								_react2.default.createElement("br", null),
								_react2.default.createElement(
									"b",
									null,
									"\xA0"
								)
							)
						)
					),
					_react2.default.createElement(
						"div",
						{ className: "col-md-4 col-sm-6 wow fadeInUp" },
						_react2.default.createElement(
							"div",
							{ className: "team-wrapper" },
							_react2.default.createElement(
								"div",
								{ className: "team-des agenda-center" },
								_react2.default.createElement(
									"h4",
									null,
									"SECURITY"
								)
							)
						),
						_react2.default.createElement(
							"div",
							{ className: "team-wrapper" },
							_react2.default.createElement(
								"div",
								{ className: "team-des agenda-center-track" },
								_react2.default.createElement(
									"h4",
									null,
									"10:25 - 10:30"
								),
								_react2.default.createElement(
									"b",
									null,
									_react2.default.createElement(
										"a",
										{ href: "/tracks/security" },
										"Track Powered by Cognizant Softvision"
									)
								),
								_react2.default.createElement("br", null),
								_react2.default.createElement(
									"a",
									{ href: "/tracks/security" },
									"opening by host"
								),
								_react2.default.createElement("br", null),
								_react2.default.createElement(
									"b",
									null,
									"\xA0"
								)
							)
						)
					),
					_react2.default.createElement(
						"div",
						{ className: "col-md-12 col-sm-6 wow fadeInUp animated" },
						_react2.default.createElement(
							"div",
							{ className: "team-wrapper" },
							_react2.default.createElement(
								"div",
								{ className: "team-des agenda-center" },
								"\xA0"
							)
						)
					),
					_react2.default.createElement(
						"div",
						{ className: "col-md-4 col-sm-6 wow fadeInUp" },
						_react2.default.createElement(
							"div",
							{ className: "team-wrapper" },
							_react2.default.createElement(
								"div",
								{ className: "team-des agenda-center-track" },
								_react2.default.createElement(
									"h4",
									null,
									"10:30 - 11:15"
								),
								_react2.default.createElement(
									"b",
									null,
									_react2.default.createElement(
										"a",
										{ href: "/speakers/cezar-romaniuc" },
										"Cezar Romaniuc"
									)
								),
								_react2.default.createElement(
									"p",
									null,
									_react2.default.createElement(
										"a",
										{ href: "/speakers/cezar-romaniuc" },
										"Incremental transition from monolith to microservices"
									)
								)
							)
						)
					),
					_react2.default.createElement(
						"div",
						{ className: "col-md-4 col-sm-6 wow fadeInUp" },
						_react2.default.createElement(
							"div",
							{ className: "team-wrapper" },
							_react2.default.createElement(
								"div",
								{ className: "team-des agenda-center-track" },
								_react2.default.createElement(
									"h4",
									null,
									"10:30 - 11:15"
								),
								_react2.default.createElement(
									"b",
									null,
									_react2.default.createElement(
										"a",
										{ href: "/speakers/tudor-teodoru" },
										"Tudor Teodoru"
									)
								),
								_react2.default.createElement(
									"p",
									null,
									_react2.default.createElement(
										"a",
										{ href: "/speakers/tudor-teodoru" },
										"How do you know if you're building what you designed?"
									)
								)
							)
						)
					),
					_react2.default.createElement(
						"div",
						{ className: "col-md-4 col-sm-6 wow fadeInUp" },
						_react2.default.createElement(
							"div",
							{ className: "team-wrapper" },
							_react2.default.createElement(
								"div",
								{ className: "team-des agenda-center-track" },
								_react2.default.createElement(
									"h4",
									null,
									"10:30 - 11:15"
								),
								_react2.default.createElement(
									"b",
									null,
									_react2.default.createElement(
										"a",
										{ href: "/speakers/leif-nixon" },
										"Leif Nixon"
									)
								),
								_react2.default.createElement(
									"p",
									null,
									_react2.default.createElement(
										"a",
										{ href: "/speakers/leif-nixon" },
										"HORRORLARITY"
									)
								)
							)
						)
					),
					_react2.default.createElement(
						"div",
						{ className: "col-md-12 col-sm-6 wow fadeInUp animated" },
						_react2.default.createElement(
							"div",
							{ className: "team-wrapper" },
							_react2.default.createElement(
								"div",
								{ className: "team-des agenda-center" },
								"\xA0"
							)
						)
					),
					_react2.default.createElement(
						"div",
						{ className: "col-md-12 col-sm-6 wow fadeInUp animated" },
						_react2.default.createElement(
							"div",
							{ className: "team-wrapper" },
							_react2.default.createElement(
								"div",
								{ className: "team-des agenda-center" },
								_react2.default.createElement(
									"h4",
									null,
									"11:15 - 11:30"
								),
								_react2.default.createElement(
									"h5",
									null,
									"COFFEE BREAK"
								)
							)
						)
					),
					_react2.default.createElement(
						"div",
						{ className: "col-md-4 col-sm-6 wow fadeInUp" },
						_react2.default.createElement(
							"div",
							{ className: "team-wrapper" },
							_react2.default.createElement(
								"div",
								{ className: "team-des agenda-center" },
								_react2.default.createElement(
									"h4",
									null,
									"CLOUD NATIVE"
								)
							)
						),
						_react2.default.createElement(
							"div",
							{ className: "team-wrapper" },
							_react2.default.createElement(
								"div",
								{ className: "team-des agenda-center-track" },
								_react2.default.createElement(
									"h4",
									null,
									"11:30 - 12:15"
								),
								_react2.default.createElement(
									"b",
									null,
									_react2.default.createElement(
										"a",
										{ href: "/speakers/adrian-mouat" },
										"Adrian Mouat"
									)
								),
								_react2.default.createElement(
									"p",
									null,
									_react2.default.createElement(
										"a",
										{ href: "/speakers/adrian-mouat" },
										"Establishing Image Provenance and Security in Kubernetes"
									)
								)
							)
						)
					),
					_react2.default.createElement(
						"div",
						{ className: "col-md-4 col-sm-6 wow fadeInUp" },
						_react2.default.createElement(
							"div",
							{ className: "team-wrapper" },
							_react2.default.createElement(
								"div",
								{ className: "team-des agenda-center" },
								_react2.default.createElement(
									"h4",
									null,
									"ARCHITECTURE"
								)
							)
						),
						_react2.default.createElement(
							"div",
							{ className: "team-wrapper" },
							_react2.default.createElement(
								"div",
								{ className: "team-des agenda-center-track" },
								_react2.default.createElement(
									"h4",
									null,
									"11:30 - 12:15"
								),
								_react2.default.createElement(
									"b",
									null,
									_react2.default.createElement(
										"a",
										{ href: "/speakers/nick-tune" },
										"Nick Tune"
									)
								),
								_react2.default.createElement(
									"p",
									null,
									_react2.default.createElement(
										"a",
										{ href: "/speakers/nick-tune" },
										"Sociotechnical domain-driven design: Aligning teams and software for continuous delivery"
									)
								)
							)
						)
					),
					_react2.default.createElement(
						"div",
						{ className: "col-md-4 col-sm-6 wow fadeInUp" },
						_react2.default.createElement(
							"div",
							{ className: "team-wrapper" },
							_react2.default.createElement(
								"div",
								{ className: "team-des agenda-center" },
								_react2.default.createElement(
									"h4",
									null,
									"SECURITY"
								)
							)
						),
						_react2.default.createElement(
							"div",
							{ className: "team-wrapper" },
							_react2.default.createElement(
								"div",
								{ className: "team-des agenda-center-track" },
								_react2.default.createElement(
									"h4",
									null,
									"11:30 - 12:15"
								),
								_react2.default.createElement(
									"b",
									null,
									_react2.default.createElement(
										"a",
										{ href: "/speakers/vicentiu-bacioiu" },
										"Vicentiu Bacioiu"
									)
								),
								_react2.default.createElement(
									"p",
									null,
									_react2.default.createElement(
										"a",
										{ href: "/speakers/vicentiu-bacioiu" },
										"OAuth Unlocked - How it actually works"
									)
								)
							)
						)
					),
					_react2.default.createElement(
						"div",
						{ className: "col-md-12 col-sm-6 wow fadeInUp animated" },
						_react2.default.createElement(
							"div",
							{ className: "team-wrapper" },
							_react2.default.createElement("div", { className: "team-des agenda-center" })
						)
					),
					_react2.default.createElement(
						"div",
						{ className: "col-md-12 col-sm-6 wow fadeInUp animated" },
						_react2.default.createElement(
							"div",
							{ className: "team-wrapper" },
							_react2.default.createElement(
								"div",
								{ className: "team-des agenda-center" },
								_react2.default.createElement(
									"h4",
									null,
									"12:15 - 13:45"
								),
								_react2.default.createElement(
									"h5",
									null,
									"LUNCH BREAK (lunch not provided) & NETWORKING"
								)
							)
						)
					),
					_react2.default.createElement(
						"div",
						{ className: "col-md-4 col-sm-6 wow fadeInUp" },
						_react2.default.createElement(
							"div",
							{ className: "team-wrapper" },
							_react2.default.createElement(
								"div",
								{ className: "team-des agenda-center" },
								_react2.default.createElement(
									"h4",
									null,
									"CLOUD NATIVE"
								)
							)
						),
						_react2.default.createElement(
							"div",
							{ className: "team-wrapper" },
							_react2.default.createElement(
								"div",
								{ className: "team-des agenda-center-track" },
								_react2.default.createElement(
									"h4",
									null,
									"13:45 - 14:30"
								),
								_react2.default.createElement(
									"b",
									null,
									_react2.default.createElement(
										"a",
										{ href: "#" },
										"Cloud Native Panel"
									)
								)
							)
						)
					),
					_react2.default.createElement(
						"div",
						{ className: "col-md-4 col-sm-6 wow fadeInUp" },
						_react2.default.createElement(
							"div",
							{ className: "team-wrapper" },
							_react2.default.createElement(
								"div",
								{ className: "team-des agenda-center" },
								_react2.default.createElement(
									"h4",
									null,
									"ARCHITECTURE"
								)
							)
						),
						_react2.default.createElement(
							"div",
							{ className: "team-wrapper" },
							_react2.default.createElement(
								"div",
								{ className: "team-des agenda-center-track" },
								_react2.default.createElement(
									"h4",
									null,
									"13:45 - 14:30"
								),
								_react2.default.createElement(
									"b",
									null,
									_react2.default.createElement(
										"a",
										{ href: "#" },
										"Architecture Panel"
									)
								)
							)
						)
					),
					_react2.default.createElement(
						"div",
						{ className: "col-md-4 col-sm-6 wow fadeInUp" },
						_react2.default.createElement(
							"div",
							{ className: "team-wrapper" },
							_react2.default.createElement(
								"div",
								{ className: "team-des agenda-center" },
								_react2.default.createElement(
									"h4",
									null,
									"SECURITY"
								)
							)
						),
						_react2.default.createElement(
							"div",
							{ className: "team-wrapper" },
							_react2.default.createElement(
								"div",
								{ className: "team-des agenda-center-track" },
								_react2.default.createElement(
									"h4",
									null,
									"13:45 - 14:30"
								),
								_react2.default.createElement(
									"b",
									null,
									_react2.default.createElement(
										"a",
										{ href: "#" },
										"Security Panel"
									)
								)
							)
						)
					),
					_react2.default.createElement(
						"div",
						{ className: "col-md-12 col-sm-6 wow fadeInUp animated" },
						_react2.default.createElement(
							"div",
							{ className: "team-wrapper" },
							_react2.default.createElement("div", { className: "team-des agenda-center" })
						)
					),
					_react2.default.createElement(
						"div",
						{ className: "col-md-12 col-sm-6 wow fadeInUp animated" },
						_react2.default.createElement(
							"div",
							{ className: "team-wrapper" },
							_react2.default.createElement(
								"div",
								{ className: "team-des agenda-center" },
								_react2.default.createElement(
									"h4",
									null,
									"14:30 - 14:45"
								),
								_react2.default.createElement(
									"h5",
									null,
									"COFFEE BREAK"
								)
							)
						)
					),
					_react2.default.createElement(
						"div",
						{ className: "col-md-4 col-sm-6 wow fadeInUp" },
						_react2.default.createElement(
							"div",
							{ className: "team-wrapper" },
							_react2.default.createElement(
								"div",
								{ className: "team-des agenda-center" },
								_react2.default.createElement(
									"h4",
									null,
									"CLOUD NATIVE"
								)
							)
						),
						_react2.default.createElement(
							"div",
							{ className: "team-wrapper" },
							_react2.default.createElement(
								"div",
								{ className: "team-des agenda-center-track" },
								_react2.default.createElement(
									"h4",
									null,
									"14:45 - 15:30"
								),
								_react2.default.createElement(
									"b",
									null,
									_react2.default.createElement(
										"a",
										{ href: "/speakers/andrew-martin" },
										"Andrew Martin"
									)
								),
								_react2.default.createElement(
									"p",
									null,
									_react2.default.createElement(
										"a",
										{ href: "/speakers/andrew-martin" },
										"In a Container Nobody Hears Your Screams: Next Generation Process Isolation"
									)
								)
							)
						)
					),
					_react2.default.createElement(
						"div",
						{ className: "col-md-4 col-sm-6 wow fadeInUp" },
						_react2.default.createElement(
							"div",
							{ className: "team-wrapper" },
							_react2.default.createElement(
								"div",
								{ className: "team-des agenda-center" },
								_react2.default.createElement(
									"h4",
									null,
									"ARCHITECTURE"
								)
							)
						),
						_react2.default.createElement(
							"div",
							{ className: "team-wrapper" },
							_react2.default.createElement(
								"div",
								{ className: "team-des agenda-center-track" },
								_react2.default.createElement(
									"h4",
									null,
									"14:45 - 15:30"
								),
								_react2.default.createElement(
									"b",
									null,
									_react2.default.createElement(
										"a",
										{ href: "/speakers/tomer-gabel" },
										"Tomer Gabel"
									)
								),
								_react2.default.createElement(
									"p",
									null,
									_react2.default.createElement(
										"a",
										{ href: "/speakers/tomer-gabel" },
										"Microservices: A retrospective"
									)
								)
							)
						)
					),
					_react2.default.createElement(
						"div",
						{ className: "col-md-4 col-sm-6 wow fadeInUp" },
						_react2.default.createElement(
							"div",
							{ className: "team-wrapper" },
							_react2.default.createElement(
								"div",
								{ className: "team-des agenda-center" },
								_react2.default.createElement(
									"h4",
									null,
									"SECURITY"
								)
							)
						),
						_react2.default.createElement(
							"div",
							{ className: "team-wrapper" },
							_react2.default.createElement(
								"div",
								{ className: "team-des agenda-center-track" },
								_react2.default.createElement(
									"h4",
									null,
									"14:45 - 15:30"
								),
								_react2.default.createElement(
									"b",
									null,
									_react2.default.createElement(
										"a",
										{ href: "/speakers/philippe-deryck" },
										"Philippe De Ryck"
									)
								),
								_react2.default.createElement(
									"p",
									null,
									_react2.default.createElement(
										"a",
										{ href: "/speakers/philippe-deryck" },
										"Common API security pitfalls"
									)
								)
							)
						)
					),
					_react2.default.createElement(
						"div",
						{ className: "col-md-12 col-sm-6 wow fadeInUp animated" },
						_react2.default.createElement(
							"div",
							{ className: "team-wrapper" },
							_react2.default.createElement("div", { className: "team-des agenda-center" })
						)
					),
					_react2.default.createElement(
						"div",
						{ className: "col-md-12 col-sm-6 wow fadeInUp animated" },
						_react2.default.createElement(
							"div",
							{ className: "team-wrapper" },
							_react2.default.createElement(
								"div",
								{ className: "team-des agenda-center" },
								_react2.default.createElement(
									"h4",
									null,
									"15:30 - 15:45"
								),
								_react2.default.createElement(
									"h5",
									null,
									"COFFEE BREAK"
								)
							)
						)
					),
					_react2.default.createElement(
						"div",
						{ className: "col-md-4 col-sm-6 wow fadeInUp" },
						_react2.default.createElement(
							"div",
							{ className: "team-wrapper" },
							_react2.default.createElement(
								"div",
								{ className: "team-des agenda-center" },
								_react2.default.createElement(
									"h4",
									null,
									"CLOUD NATIVE"
								)
							)
						),
						_react2.default.createElement(
							"div",
							{ className: "team-wrapper" },
							_react2.default.createElement(
								"div",
								{ className: "team-des agenda-center-track" },
								_react2.default.createElement(
									"h4",
									null,
									"15:45 - 16:30"
								),
								_react2.default.createElement(
									"b",
									null,
									_react2.default.createElement(
										"a",
										{ href: "#" },
										"TBA"
									)
								),
								_react2.default.createElement(
									"p",
									null,
									_react2.default.createElement(
										"a",
										{ href: "#" },
										"TBA"
									)
								)
							)
						)
					),
					_react2.default.createElement(
						"div",
						{ className: "col-md-4 col-sm-6 wow fadeInUp" },
						_react2.default.createElement(
							"div",
							{ className: "team-wrapper" },
							_react2.default.createElement(
								"div",
								{ className: "team-des agenda-center" },
								_react2.default.createElement(
									"h4",
									null,
									"ARCHITECTURE"
								)
							)
						),
						_react2.default.createElement(
							"div",
							{ className: "team-wrapper" },
							_react2.default.createElement(
								"div",
								{ className: "team-des agenda-center-track" },
								_react2.default.createElement(
									"h4",
									null,
									"15:45 - 16:30"
								),
								_react2.default.createElement(
									"b",
									null,
									_react2.default.createElement(
										"a",
										{ href: "/speakers/vladik-khononov" },
										"Vladik Khononov"
									)
								),
								_react2.default.createElement(
									"p",
									null,
									_react2.default.createElement(
										"a",
										{ href: "/speakers/vladik-khononov" },
										"Microservices, bounded contexts, and everything in between"
									)
								)
							)
						)
					),
					_react2.default.createElement(
						"div",
						{ className: "col-md-4 col-sm-6 wow fadeInUp" },
						_react2.default.createElement(
							"div",
							{ className: "team-wrapper" },
							_react2.default.createElement(
								"div",
								{ className: "team-des agenda-center" },
								_react2.default.createElement(
									"h4",
									null,
									"SECURITY"
								)
							)
						),
						_react2.default.createElement(
							"div",
							{ className: "team-wrapper" },
							_react2.default.createElement(
								"div",
								{ className: "team-des agenda-center-track" },
								_react2.default.createElement(
									"h4",
									null,
									"15:45 - 16:30"
								),
								_react2.default.createElement(
									"b",
									null,
									_react2.default.createElement(
										"a",
										{ href: "/speakers/christian-wenz" },
										"Christian Wenz"
									)
								),
								_react2.default.createElement(
									"p",
									null,
									_react2.default.createElement(
										"a",
										{ href: "/speakers/christian-wenz" },
										"The Ten Most Critical Web Application Security Risks: OWASP Top Ten"
									)
								)
							)
						)
					),
					_react2.default.createElement(
						"div",
						{ className: "col-md-12 col-sm-6 wow fadeInUp animated" },
						_react2.default.createElement(
							"div",
							{ className: "team-wrapper" },
							_react2.default.createElement("div", { className: "team-des agenda-center" })
						)
					),
					_react2.default.createElement(
						"div",
						{ className: "col-md-12 col-sm-6 wow fadeInUp animated" },
						_react2.default.createElement(
							"div",
							{ className: "team-wrapper" },
							_react2.default.createElement(
								"div",
								{ className: "team-des agenda-center" },
								_react2.default.createElement(
									"h4",
									null,
									"16:30 - 16:45"
								),
								_react2.default.createElement(
									"h5",
									null,
									"COFFEE BREAK"
								)
							)
						)
					),
					_react2.default.createElement(
						"div",
						{ className: "col-md-12 col-sm-6 wow fadeInUp animated" },
						_react2.default.createElement(
							"div",
							{ className: "team-wrapper" },
							_react2.default.createElement(
								"div",
								{ className: "team-des agenda-center" },
								_react2.default.createElement(
									"h4",
									null,
									"16:45 - 17:30"
								),
								_react2.default.createElement(
									"h5",
									null,
									_react2.default.createElement(
										"a",
										{ href: "/speakers/nicky-wrightson" },
										"Closing keynote"
									)
								),
								_react2.default.createElement(
									"b",
									null,
									_react2.default.createElement(
										"a",
										{ href: "/speakers/nicky-wrightson" },
										"Nicky Wrightson"
									)
								),
								_react2.default.createElement(
									"p",
									null,
									_react2.default.createElement(
										"a",
										{ href: "/speakers/nicky-wrightson" },
										"An Engineer's Guide to a Good Night's Sleep"
									)
								)
							)
						)
					),
					_react2.default.createElement(
						"div",
						{ className: "col-md-12 col-sm-6 wow fadeInUp animated" },
						_react2.default.createElement(
							"div",
							{ className: "team-wrapper" },
							_react2.default.createElement("div", { className: "team-des agenda-center" })
						)
					),
					_react2.default.createElement(
						"div",
						{ className: "col-md-12 col-sm-6 wow fadeInUp animated" },
						_react2.default.createElement(
							"div",
							{ className: "team-wrapper" },
							_react2.default.createElement(
								"div",
								{ className: "team-des agenda-center" },
								_react2.default.createElement(
									"h4",
									null,
									"17:30 - 18:30"
								),
								_react2.default.createElement(
									"h5",
									null,
									"GEEK PARTY & NETWORKING"
								)
							)
						)
					)
				)
			)
		);
	};
	
	exports.default = ConferenceAgenda;
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-agenda-js-92173bde746e3208f78d.js